import React from 'react'

import { CSSProperties } from 'styled-components'
import { useWindowSize } from 'utils/hooks/useWindowSize'
import { sm } from 'utils/style-utils'

import { SlideMedia } from '../validation'
import { ImageStyle } from './styles'

interface Props {
  media: SlideMedia
}

export function Image({ media }: Props) {
  const { width } = useWindowSize()
  const smImages = [
    `"${media.picture.lg.avif}" 2x type("image/avif")`,
    `"${media.picture.lg.webp}" 2x type("image/webp")`,
    `"${media.picture.lg.png}" 2x type("image/png")`,
    `"${media.picture.sm.avif}" 1x type("image/avif")`,
    `"${media.picture.sm.webp}" 1x type("image/webp")`,
    `"${media.picture.sm.png}" 1x type("image/png")`,
  ]
  const lgImages = [
    `"${media.picture.lg.avif}" type("image/avif")`,
    `"${media.picture.lg.webp}" type("image/webp")`,
    `"${media.picture.lg.png}" type("image/png")`,
  ]
  const images = width <= sm ? smImages : lgImages
  const style: CSSProperties = {
    backgroundImage: 'image-set(' + images.join(',') + ')',
  }

  return <ImageStyle style={style} />
}
